const pepePhoneParticular1 = [
    {
        "tipoVenta": "ALTA_NUEVA",
        "tipoLinea": "LINEA_ADICIONAL",
        "tarifa": {
            "id": "PPOSCONVERGENTPEPEPHONE14",
            "price": 42.066,
            "name": "Fibra 600 + La Inimitable 99 GB con Netflix",
            "operator": "PEPEPHONE",
            "segment": "PARTICULAR",
            "category": "convergent",
            "color": "",
            "commercial_enrichment": "",
            "description_file": "",
            "fixed_line_info": {
                "type": "",
                "owners": [],
                "upload_speed": {
                    "unit": "Mb",
                    "amount": 0
                },
                "download_speed": {
                    "unit": "Mb",
                    "amount": 0
                },
                "voice_to_fixed": {
                    "unit": "min",
                    "amount": 0
                },
                "voice_to_mobile": {
                    "unit": "min",
                    "amount": 0
                }
            },
            "mobile_line_info": {
                "mobile_line_data": {
                    "unit": "GB",
                    "amount": 0
                },
                "mobile_line_voice": {
                    "unit": "min",
                    "amount": 0
                }
            },
            "payment_type": "postpaid",
            "is_active": true,
            "created_on": "2022-05-25T00:45:13.938041+02:00",
            "updated_on": "2022-05-25T00:45:13.946057+02:00",
            "svas": [],
            "promotions": [
                "PROMOPEPEPHONE"
            ],
            "additional_lines": []
        },
        "cacharro": null,
        "installment": null,
        "seguro": null,
        "lineasAsociadas": [],
        "crossSell": false,
        "promotion": []
    }
]
export default pepePhoneParticular1;